
import * as d3 from 'd3'
export default {
  methods: {

    draw_Contents() {
      
      let dataGroup = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.table.x}, ${this.table.y + this.table.headHeight})`)
      .attr('font-family', 'roboto')

      let y_ = 13
      this.rawData.forEach(d=> {

        let row = dataGroup
        .append('g')
        .attr('transform', `translate(0, ${y_})`)
        .attr('cursor', 'pointer')
        .call(this.call_List, d.SN)

        this.columns.forEach((col,c)=> {
          let x_ = c>2 ? col.tx - 6 : col.tx

          row
          .append('text')
          .attr('transform', `translate(${x_}, 0)`)
          .attr('font-size', 10).attr('fill', d[col.code] == 0 ? '#E0E0DF' : '#606060')
          .attr('text-anchor', col.align)
          .text(d[col.code])
          .call(this.event_Link, d, col, x_)
        })
        y_ += this.table.lineHeight
      })

    },

  }
}